// import { lazy } from "react";

// // Authentication related pages
// import Login from "../pages/Auth/index";
//import Register from "../pages/Auth/register";
import EmployeeLogin from "../pages/Auth/employeeLogin";
//import EmployeeRegister from "../pages/Auth/employeeRegister";

// import Landing from "../pages/Landing/index";
// import UserDetails from "../pages/User-Details/index";
// const Landing = lazy(() => import("../pages/Landing/index"));

//Dashboard
import Dashboard from "../pages/Dashboard/index";

import NotFound from "../pages/NotFoundPage/index";

//Settings
import AccountSettings from "../pages/Settings/index";
import ManageBusiness from "../pages/Settings/manage-business";
import ManageUsers from "../pages/Settings/manage-users";
import Reminders from "../pages/Settings/reminders";
import HelpSupport from "../pages/Settings/help-support";
//import EmployeeManagementDetails from "../pages/EmployeeManagement";
//import UserDetails from "../pages/User-Details";
import EmployeeManagementDetails from "../pages/EmployeeManagement";
import AttendenceDetails from "../pages/Attendence/Attendance";
import LeaveDetails from "../pages/LeaveAndPermissions/LeaveDetails";
import Permission from "../pages/LeaveAndPermissions/Permission";
import EmployeeLeaveRecord from "../pages/Records/EmployeeLeaveRecord";
import EmployeeList from "../pages/Records/EmployeeList";
import LoseOfPayDetails from "../pages/LeaveAndPermissions/LossOfPay";
import AttendanceDetails from "../pages/Records/AttendanceView";
import Department from "../pages/Masters/Department";
import Designation from "../pages/Masters/Designation";
import Role from "../pages/Masters/Role";
import LoginShift from "../pages/Masters/LoginShift";
import LopSetting from "../pages/Masters/LopSetting";
import Holiday from "../pages/Masters/Holiday";
import LocationManager from "../pages/Masters/Locations/LocationManager";
import ProjectMenu from "../pages/Project/project";
import ProjectsMenu from "../pages/Records/ProjectList";
import Phase from "../pages/Project/phase"



//Auth protected routes
const authProtectedRoutes = [
  { path: "/employee-dashboard", exact: true, component: Dashboard },
  { path: "/not-found", exact: true, component: NotFound },
  
  { path: "/settings/account", exact: true, component: AccountSettings },
  { path: "/settings/manage-business", exact: true, component: ManageBusiness },
  // { path: "/settings/user-roles", exact: true, component: UserRole },
  
  { path: "/settings/manage-users", exact: true, component: ManageUsers },
  { path: "/settings/reminders", exact: true, component: Reminders },
  { path: "/settings/help-support", exact: true, component: HelpSupport },
  { path: "/employee-management", exact: true, component:EmployeeManagementDetails },
  {path:"/attendance",exact:true,component:AttendenceDetails},
  {path:"/leave-details",exact:true,component:LeaveDetails},
  {path:"/permission",exact:true,component:Permission},
  {path:"/employee-leave-record",exact:true,component:EmployeeLeaveRecord},
  {path:"/employee-list",exact:true,component:EmployeeList},
  {path:"/lop",exact:true,component:LoseOfPayDetails},
  {path:"/attendance-detail",exact:true,component:AttendanceDetails},
  {path:"/department",exact:true,component:Department},
  {path:"/designation",exact:true,component:Designation},
  {path:"/role",exact:true,component:Role},
  {path:"/login-shift",exact:true,component:LoginShift},
  {path:"/lop-settings",exact:true,component:LopSetting},
  {path:"/holiday",exact:true,component:Holiday},
  {path:"/location",exact:true,component:LocationManager},
  {path:"/project",exact:true,component:ProjectMenu},
  {path:"/project-list",exact:true,component:ProjectsMenu},
  {path:"/phase",exact:true,component:Phase}

]

const publicRoutes = [
  { path: "/", exact: true, component: EmployeeLogin },
  // { path: "/login", component: Login },
  { path: "/employee-login", component: EmployeeLogin },
 

];

export { authProtectedRoutes, publicRoutes };
